<template>
    <div class="echart" :id="id" :style="{background:bgColor}"></div>
</template>
<script>
export default {
    name: "d3chart",
    props:{
        id:{
            type:String
        },
        textPosition:{
            type:String,
            default:'top'
        },
        bgColor:{
            type:String,
            default:'#fff'
        },
        textColor:{
            type:String,
            default:'#fff'
        },
        lineColor:{
            type:String,
            default:'#fff'
        },
        dataArry:{
            type: Array | Object
        },
        crieSize:{
            type:Number,
            default:20
        }
    },
    data() {
        return {
            myChart:'',
            already:[]
        }
    },
    watch: {
        dataArry:{
            handler(){
                this.init(); 
            },deep:true
        }
    },
    mounted() {
        let that = this;
        this.init();
    },
    methods: {
        // 去重
        unique (arr){
            const res = new Map();
            // if(arr.length <= 0) return;
            return arr.filter((a) => !res.has(a.name) && res.set(a.name, 1))
        },
        returnOption (){
            let that = this;
            let cates = [
                { name: '类目1' },
                { name: '类目2' },
                { name: '类目3' },
                { name: '类目4' },
                { name: '类目5' },
                { name: '类目6' },
                { name: '类目7' },
                { name: '类目8' },
                { name: '类目9' },
                { name: '类目10' },
                { name: '类目11' },
                { name: '类目12' },
                { name: '类目13' }
            ]
            let option = {
                tooltip: {
                    show:true,
                    formatter:"{b}"
                },
                animation: false,
                edgeLabel: {
                    normal: {
                        show: true,
                        textStyle: {
                            fontSize: 10
                        },
                        formatter: "{c}"
                    }
                },
                series: [
                    {
                        name: '',
                        type: 'graph',
                        label: {
                            show: true
                        },
                        lineStyle:{
                            color:that.lineColor
                        },
                        layout: 'force',
                        symbolSize: that.crieSize,
                        position: ['50%', '50%'],
                        data: that.unique(that.dataArry.nodes),
                        links: that.dataArry.links,
                        edgeSymbol: ['', 'arrow'],
                        edgeSymbolSize: [8, 4],
                        edgeLabel: {
                            normal: {
                                show: true,
                                textStyle: {
                                    fontSize: 10
                                },
                                formatter: "{c}"
                            }
                        },
                        roam: true,
                        categories: cates,
                        label: {
                            position: that.textPosition,
                            color:that.textColor
                        },
                        force: {
                            repulsion: 1000,
                            friction: 0.1,
                            gravity: 0.3,
                        }
                    }
                ]
            }
            return option;
        },
        init (){
            let that = this;
            that.myChart = that.$echarts.init(document.getElementById(that.id))
            that.myChart.setOption(that.returnOption());
            // 拉动定位
            that.myChart.on('mouseup', function (params) {
                let option = that.myChart.getOption();
                option.series[0].data[params.dataIndex].x = params.event.offsetX;
                option.series[0].data[params.dataIndex].y = params.event.offsetY;
                option.series[0].data[params.dataIndex].fixed = true;
                // that.myChart.setOption(option);
            });
            // 点击节点加载更多
            that.myChart.on('click', function (params) {
                if(that.already.indexOf(params.data.nodeId) != -1){//已经点过的不能再点
                    return;
                }
                that.already.push(params.data.nodeId);
                let option = that.myChart.getOption();
                that.$emit('nodeClick',params.data.name,params.data.nodeId,params.data.category);
            });
        }
    }
}
</script>
<style>
.echart{
    width: 100%;height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/echart/d3Chart.vue